export default {
  companyfavorite: {
    default: "Lieux et hôtels favoris",
    list: {
      page_title: "Liste des lieux et hôtels favoris"
    },
    create: {
      page_title: "Création d'un favori"
    },
    edit: {
      page_title: "Modification favori"
    },
    show: {
      page_title: "Fiche favori"
    }
  }
}
